import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioGroupModule } from '@liberty-financial/ng-components';

import { PipesModule } from '@shared/pipes/pipes.module';

import { YesOrNoQuestionComponent } from './yes-or-no/yes-or-no.component';

@NgModule({
  declarations: [YesOrNoQuestionComponent],
  exports: [YesOrNoQuestionComponent],
  imports: [CommonModule, ReactiveFormsModule, RadioGroupModule, PipesModule]
})
export class SparkSharedQuestionModule {}
